import { render, staticRenderFns } from "./LiveEventsTable.vue?vue&type=template&id=f3aa87e2&scoped=true"
import script from "./LiveEventsTable.vue?vue&type=script&lang=js"
export * from "./LiveEventsTable.vue?vue&type=script&lang=js"
import style0 from "./LiveEventsTable.vue?vue&type=style&index=0&id=f3aa87e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa87e2",
  null
  
)

export default component.exports